import { render, staticRenderFns } from "./business-blog-learning-habits.vue?vue&type=template&id=d8737c8c&"
import script from "./business-blog-learning-habits.vue?vue&type=script&lang=js&"
export * from "./business-blog-learning-habits.vue?vue&type=script&lang=js&"
import style0 from "./business-blog-learning-habits.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports